export default __webpack_public_path__ + "static/butik_img6-0d0f0b5dd7c6a668d88fa2de4002bcc7.png";